import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function NewReservationDialog({ open, onOpenChange, onCreated }) {
  const { business } = useAuth();
  const mode = business?.mode || "slot";
  const [form, setForm] = useState({
    customer_name: "", customer_phone: "", customer_email: "", party_size: 2,
    date: new Date().toISOString().slice(0, 10), time: "20:00",
    checkin: new Date().toISOString().slice(0, 10), checkout: "", notes: "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.customer_name || !form.customer_phone) { toast.error("Nome e telefono obbligatori"); return; }
    setSaving(true);
    try {
      const payload = {
        customer_name: form.customer_name, customer_phone: form.customer_phone,
        customer_email: form.customer_email, party_size: Number(form.party_size), notes: form.notes,
        ...(mode === "slot" ? { date: form.date, time: form.time } : { checkin: form.checkin, checkout: form.checkout }),
      };
      await api.post("/reservations", payload);
      toast.success("Prenotazione creata e WhatsApp inviato ✅");
      onOpenChange(false);
      onCreated && onCreated();
    } catch (e) {
      toast.error(apiErr(e));
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="new-reservation-dialog">
        <DialogHeader><DialogTitle className="font-heading">Nuova prenotazione</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Nome cliente</Label>
            <Input data-testid="res-name-input" value={form.customer_name} onChange={(e) => set("customer_name", e.target.value)} placeholder="Mario Rossi" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Telefono</Label>
              <Input data-testid="res-phone-input" value={form.customer_phone} onChange={(e) => set("customer_phone", e.target.value)} placeholder="+39 333..." />
            </div>
            <div>
              <Label>{mode === "slot" ? "Coperti" : "Ospiti"}</Label>
              <Input data-testid="res-party-input" type="number" min={1} value={form.party_size} onChange={(e) => set("party_size", e.target.value)} />
            </div>
          </div>
          <div>
            <Label>Email (opzionale)</Label>
            <Input data-testid="res-email-input" value={form.customer_email} onChange={(e) => set("customer_email", e.target.value)} placeholder="email@..." />
          </div>
          {mode === "slot" ? (
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Data</Label><Input data-testid="res-date-input" type="date" value={form.date} onChange={(e) => set("date", e.target.value)} /></div>
              <div><Label>Ora</Label><Input data-testid="res-time-input" type="time" value={form.time} onChange={(e) => set("time", e.target.value)} /></div>
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Check-in</Label><Input data-testid="res-checkin-input" type="date" value={form.checkin} onChange={(e) => set("checkin", e.target.value)} /></div>
              <div><Label>Check-out</Label><Input data-testid="res-checkout-input" type="date" value={form.checkout} onChange={(e) => set("checkout", e.target.value)} /></div>
            </div>
          )}
          <div><Label>Note</Label><Textarea data-testid="res-notes-input" value={form.notes} onChange={(e) => set("notes", e.target.value)} placeholder="Allergie, richieste speciali..." /></div>
        </div>
        <DialogFooter>
          <Button data-testid="res-submit-btn" onClick={submit} disabled={saving} className="w-full rounded-xl">
            {saving ? "Salvataggio..." : "Crea prenotazione"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
